import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ServiceRepairFinderFilter } from '../models/service-repair-finder-filter.model';

/**
 * Shares the Service/Repair Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FboFinderFiltersService} (a root-provided BehaviorSubject).
 */
@Injectable({
  providedIn: 'root'
})
export class ServiceRepairFinderFiltersService {

  private serviceRepairFinderFilterSubject$ = new BehaviorSubject<ServiceRepairFinderFilter>(new ServiceRepairFinderFilter());
  serviceRepairFinderFilter = this.serviceRepairFinderFilterSubject$.asObservable();

  constructor() { }

  updateServiceRepairFinderFilters(serviceRepairFinderFilter: ServiceRepairFinderFilter) {
    this.serviceRepairFinderFilterSubject$.next(serviceRepairFinderFilter);
  }
}
